import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../api.js'
import { qk } from './keys.js'

export const meQuery = queryOptions({
  queryKey: qk.me,
  queryFn: ({ signal }) => api('/me', { signal }),
  staleTime: 5 * 60_000,
})

export function useMe() {
  const { data } = useQuery(meQuery)
  return { user: data?.user ?? null, workspace: data?.workspace ?? null }
}

export function useAuthConfig() {
  return useQuery({
    queryKey: qk.authConfig,
    queryFn: async () => {
      const response = await fetch('/auth/config', { credentials: 'same-origin' })
      if (!response.ok) throw new Error('Could not load sign-in options.')
      return response.json()
    },
    staleTime: Infinity,
  })
}

async function post(path) {
  const response = await fetch(path, { method: 'POST', credentials: 'same-origin' })
  if (!response.ok) {
    const data = await response.json().catch(() => null)
    throw new Error(data?.error?.message ?? 'Request failed.')
  }
}

export function useSignOut() {
  const queryClient = useQueryClient()
  return async ({ everywhere = false } = {}) => {
    await post(everywhere ? '/auth/logout-all' : '/auth/logout').catch(() => {})
    queryClient.clear()
    window.location.assign('/login')
  }
}

export const devLogin = () => post('/auth/dev-login')
